import { ReportAnswerKPI } from '../../utils/reportKPI';
import {
  FETCH_KPI_DATA_REQUEST,
  FETCH_KPI_DATA_SUCCESS,
  FETCH_KPI_DATA_FAILURE,
  FETCH_KPI_CHART_DATA_REQUEST,
  FETCH_KPI_CHART_DATA_SUCCESS,
  FETCH_KPI_CHART_DATA_FAILURE,
  KPIActionTypes,
} from './actions';

export interface ReportKPIState {
  answers: ReportAnswerKPI[];
  statuses: any[];
  loading: boolean;
  error: string | null;
  chartData: {
    kpiPlan: Array<{ value: number; label: string }>;
    kpiFact: Array<{ value: number; label: string }>;
  };
  chartLoading: boolean;
  chartError: string | null;
}

const initialState: ReportKPIState = {
  answers: [],
  statuses: [],
  loading: false,
  error: null,
  chartData: {
    kpiPlan: [],
    kpiFact: [],
  },
  chartLoading: false,
  chartError: null,
};

export const reportKPIReducer = (state = initialState, action: KPIActionTypes): ReportKPIState => {
  switch (action.type) {
    case FETCH_KPI_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_KPI_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        answers: action.payload.answers,
        statuses: action.payload.statuses,
        error: null,
      };
    case FETCH_KPI_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case FETCH_KPI_CHART_DATA_REQUEST:
      return {
        ...state,
        chartLoading: true,
        chartError: null,
      };
    case FETCH_KPI_CHART_DATA_SUCCESS:
      return {
        ...state,
        chartLoading: false,
        chartData: {
          kpiPlan: action.payload.kpiPlan,
          kpiFact: action.payload.kpiFact,
        },
        chartError: null,
      };
    case FETCH_KPI_CHART_DATA_FAILURE:
      return {
        ...state,
        chartLoading: false,
        chartError: action.payload.error,
      };
    default:
      return state;
  }
};
